import { render, staticRenderFns } from "./ClientHistoryList.vue?vue&type=template&id=8f497a82&"
import script from "./ClientHistoryList.vue?vue&type=script&lang=js&"
export * from "./ClientHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./ClientHistoryList.vue?vue&type=style&index=0&id=8f497a82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports